/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IProductFeatureViewProps } from './product-feature';

export default (props: IProductFeatureViewProps) => {
    return (
    <div className='main-container'>
         <div className='random-class-1'>
          <h6>{props.config.showText}</h6>
        </div>
        <div className='random-class-2'>
               <p>{props.config.showText}</p>
                <p></p>
                 <button type='button' className='btn btn-primary'></button>
        </div>
    </div>)
};
